"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundNumber = exports.hydrateStringWithApiResponse = exports.hydrateConfigWithApiResponse = exports.formatNumberReset = exports.formatDate = exports.formatNumberCurrency = void 0;
/**
 * Format the number as currency
 * @param {float/int} number the number to format
 * @param {int} roundType number of decimal places to round (def null=don't round)
 * @param {currencySymbol} symbol
 * @param {string} decimal Text to use as decimal separator (if not '.' then thousands separator becomes '.')
 * @param {boolean} isPost Should the Symbol be after the number?
 */
const formatNumberCurrency = (number = 0, roundType = 'never', terms = {
    currencySymbol: '$',
    currencyDecimal: '.',
    currencyDisplayPost: false,
}) => {
    let str = '0';
    if (roundType === 'always') {
        str = number.toFixed(2);
    }
    else if (roundType === 'never') {
        str = number.toFixed(0);
    }
    else if (roundType === 'ifPresent') {
        str =
            number - Math.floor(number) !== 0
                ? (str = number.toFixed(2))
                : (str = number.toFixed(0));
    }
    const symbol = (terms === null || terms === void 0 ? void 0 : terms.currencySymbol) || '$';
    const decimal = terms.currencyDecimal || '.';
    const isPost = terms.currencyDisplayPost || false;
    const separator = decimal === '.' ? ',' : '.';
    // let str = numberString ? numberString.toString() : '0'
    const parts = str.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${separator}`);
    str = parts.join(decimal);
    return isPost ? `${str} ${symbol}` : `${symbol}${str}`;
};
exports.formatNumberCurrency = formatNumberCurrency;
const formatNumberReset = (string) => {
    return parseFloat(string.replace(/,/g, ''));
};
exports.formatNumberReset = formatNumberReset;
const placeholderRegex = /\{\{response\.([a-zA-Z0-9_.[\]]+)\}\}/g;
const accessNestedValue = (obj, path) => {
    return path
        .replace(/\[(\d+)\]/g, '.$1') // Convert array indices to dot notation (e.g., "years[0]" to "years.0")
        .split('.')
        .reduce((acc, key) => acc && typeof acc === 'object' && key in acc
        ? acc[key]
        : null, obj);
};
/**
 * Replace placeholders in a configuration object with values from a nested API response
 * @param {T} config - The configuration object with placeholders
 * @param {Record<string, any>} data - The data object used to hydrate the placeholders
 * @returns {T} - The hydrated configuration object
 */
const hydrateConfigWithApiResponse = (config, data) => {
    // Replace placeholders in the config with corresponding values from data
    return JSON.parse(JSON.stringify(config).replace(placeholderRegex, (match, path) => {
        const value = accessNestedValue(data, path);
        return value !== null && value !== undefined ? String(value) : match;
    }));
};
exports.hydrateConfigWithApiResponse = hydrateConfigWithApiResponse;
const hydrateStringWithApiResponse = (input, data) => {
    return input.replace(placeholderRegex, (match, path) => {
        const value = accessNestedValue(data, path);
        return value !== null && value !== undefined ? String(value) : match;
    });
};
exports.hydrateStringWithApiResponse = hydrateStringWithApiResponse;
const formatDate = (date) => {
    const dateObj = new Date(date);
    const formattingOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    };
    return new Intl.DateTimeFormat('default', formattingOptions).format(dateObj);
};
exports.formatDate = formatDate;
/**
 * Round a number to x decimal places
 * num any numeric value
 * type 'ceil', 'round', 'floor'
 * prec: 100 = to 2 decimal places, 1 = to nearest integer, 0.01 = to nearest 100
 */
const roundNumber = (num, type, prec = 1) => {
    if (!type || !['ceil', 'round', 'floor'].includes(type))
        return num;
    return num > 0
        ? Math[type]((num + Number.EPSILON) * prec) / prec
        : 1 - Math[type]((1 - num + Number.EPSILON) * prec) / prec;
};
exports.roundNumber = roundNumber;
